import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';

import { useGetUserBeforeImpersonate } from './useGetUserBeforeImpersonate';

import {
  COOKIES_SETTINGS,
  IMPERSONATE_RETURN_URL_COOKIE,
  STUDENT_DETAIL_REFERRER_COOKIE
} from '@/constants';
import { sdk } from '@/services';

const MAIN_TOKEN_COOKIE = 'token';
const IMPERSONATE_TOKEN_COOKIE = 'impersonateToken';

const AuthService = sdk.getService('AuthService');

export const useImpersonate = () => {
  const mainToken = Cookies.get(MAIN_TOKEN_COOKIE);
  const impersonateToken = Cookies.get(IMPERSONATE_TOKEN_COOKIE);
  const location = useLocation();

  const { setUserIdByEmail, getUserId, clearUserId } = useGetUserBeforeImpersonate();

  const isImpersonating = !!impersonateToken;

  const impersonateUser = async (email: string) => {
    await setUserIdByEmail(email);

    const referrerCookie = Cookies.get(STUDENT_DETAIL_REFERRER_COOKIE);
    let returnUrl = location.pathname + location.search;

    if (referrerCookie) {
      try {
        const { url, userId } = JSON.parse(referrerCookie);
        if (location.pathname === `/academy/students/${userId}`) {
          returnUrl = url;
        }
        Cookies.remove(STUDENT_DETAIL_REFERRER_COOKIE, COOKIES_SETTINGS);
      } catch {
        Cookies.remove(STUDENT_DETAIL_REFERRER_COOKIE, COOKIES_SETTINGS);
      }
    }

    Cookies.set(IMPERSONATE_RETURN_URL_COOKIE, returnUrl, COOKIES_SETTINGS);

    const { token } = await AuthService.impersonate(email);
    if (token && mainToken) {
      Cookies.set(IMPERSONATE_TOKEN_COOKIE, mainToken, COOKIES_SETTINGS);
      Cookies.set(MAIN_TOKEN_COOKIE, token, COOKIES_SETTINGS);
      window.location.href = '/';
    }
  };

  const stopImpersonating = () => {
    const impersonatedUserId = getUserId();
    if (mainToken && impersonateToken) {
      Cookies.set(MAIN_TOKEN_COOKIE, impersonateToken, COOKIES_SETTINGS);
      Cookies.remove(IMPERSONATE_TOKEN_COOKIE, COOKIES_SETTINGS);
      clearUserId();
      window.location.href = impersonatedUserId
        ? `/academy/students/${impersonatedUserId}`
        : '/academy/students';
    }
  };

  return {
    impersonateUser,
    isImpersonating,
    stopImpersonating
  };
};
